export const InjectableMetadataKey = "paperbits-injectable";